import {twMerge} from "tailwind-merge";
import {memo, useState} from "react";

const SimpleDropdown = memo(function SimpleDropdown({
                                                        activeItem = {},
                                                        required,
                                                        rowLabel,
                                                        texts = {},
                                                        classes = {},
                                                        options = [],
                                                        optionValueKey = "value",
                                                        onChange,
                                                        disabled
                                                    }) {

    const [showDropdown, setShowDropdown] = useState(false);

    const {
        parentClasses = "",
        labelClasses = "",
        triggerClasses = "",
        dropdownClasses = "",
        bodyDropdownClasses = ""
    } = classes;
    const {label = "", placeholder = "انتخاب کنید"} = texts;

    const changeHandler = (item) => {
        setShowDropdown(false);
        onChange(item);
    }

    return (
        <div className={twMerge(`${disabled ? "opacity-50 cursor-not-allowed pointer-events-none" : ""} ${rowLabel ? "xl:inline-flex items-center" : ""}`, parentClasses)}>
            {
                label ?
                    <p className={twMerge(`text-pol-gray text-sm ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2.5 mr-2.5"}`, labelClasses)}>
                        {label}
                        {
                            required ? <span className="align-super text-pol-red text-sm">*</span> : null
                        }
                    </p>
                    : null
            }

            <div className={twMerge("relative", dropdownClasses)}>
                <button
                    type="button"
                    onClick={() => setShowDropdown(true)}
                    className={twMerge("w-full rounded-2xl border border-pol-gray-light-3 bg-pol-light-7 px-4 py-3.5 flex items-center justify-between text-pol-dark-800", triggerClasses)}>
                    <span>{activeItem.name ? activeItem.name : placeholder}</span>
                    <i className="icon-left-arrow text-xs"/>
                </button>

                <ul className={twMerge(`absolute z-20 space-y-2 text-sm text-pol-dark-800 w-full max-h-[300px] overflow-y-auto bg-white -top-px border border-pol-gray-light-3 rounded-2xl px-4 py-3.5 ${showDropdown ? "" : "hidden"}`, bodyDropdownClasses)}>
                    {
                        options.map(item => (
                            <li key={item[optionValueKey]}
                                className={item[optionValueKey] === activeItem[optionValueKey] ? "text-pol-main-purple" : ""}>
                                <button
                                    type="button"
                                    className="w-full text-right"
                                    onClick={() => changeHandler(item)}>{item.name}</button>
                            </li>
                        ))
                    }
                </ul>
            </div>

            {
                showDropdown ?
                    <div className="fixed z-10 top-0 left-0 w-full h-full" onClick={() => setShowDropdown(false)}/>
                    : null
            }
        </div>
    )
})

export default SimpleDropdown;
